export type UserTypeProps = {
	type?: string;
	userType: number;
};

export const SET_USER_TYPE = 'SET_USER_TYPE';
